import { Home } from '../components/pages/Home';
import { CurrentView } from '../components/pages/CurrentView';
import { HistoryView } from '../components/pages/HistoryView';
import { IssueDetail } from '../components/pages/IssueDetail';
import { IssueGroupDetail } from '../components/pages/IssueGroupDetail';
import { NoticeView } from '../components/pages/NoticeView';
import { NoticeDetail } from '../components/pages/NoticeDetail';
import { CaseView } from '../components/pages/CaseView';
import { Dashboard } from '../components/pages/Dashboard';
import { TenantList } from '../components/pages/TenantList';
// import { HealthGroupDetails } from '../components/pages/healthgroup/HealthGroupDetails';
// import { HealthGroupUpdates } from '../components/pages/healthgroup/HealthGroupUpdates';
// import { HealthGroupList } from '../components/pages/healthgroup/HealthGroupList';
// import { MyPage } from '../components/pages/dashboard/MyPage';
// import { GroupSummary } from '../components/pages/dashboard/GroupSummary';
// import { IssueDetail } from '../components/pages/dashboard/IssueDetail';
// import { IssueDiff } from '../components/pages/dashboard/IssueDiff';
// import { HandleMail } from '../components/pages/HandleMail';
// import { AccountDetail } from '../components/pages/AccountDetail';
// import { MailDetail } from '../components/pages/dashboard/MailDetail';
import { ReloadURL } from '../components/pages/ReloadURL';
import { Page404 } from '../components/pages/Page404';

export const routes = [
  {
    name: 'ホーム',
    path: '/home',
    children: <Home />,
  },
  {
    name: '最新状況',
    path: '/currentView',
    children: <CurrentView />,
  },
  {
    name: 'クラウド障害履歴',
    path: '/historyView',
    children: <HistoryView />,
  },
  {
    name: '通知メール履歴',
    path: '/noticeView',
    children: <NoticeView />,
  },
  {
    name: '障害詳細',
    path: '/issueDetail',
    children: <IssueDetail />,
  },
  {
    name: '障害グループ詳細',
    path: '/issueGroupDetail',
    children: <IssueGroupDetail />,
  },
  {
    name: 'メール詳細',
    path: '/noticeDetail',
    children: <NoticeDetail />,
  },
  {
    name: '問い合わせ履歴',
    path: '/caseView',
    children: <CaseView />,
  },
  {
    name: 'その他関連情報',
    path: '/dashboard',
    children: <Dashboard />,
  },
  {
    name: '共通サポートID追加',
    path: '/addUser',
    children: <TenantList page='addUser' />,
  }, 
  {
    name: 'テナント一覧本体',
    path: '/tenantList',
    children: <TenantList page='home' />,
  },
  {
    name: 'リロード',
    path: '/reloadURL',
    children: <ReloadURL />,
  },
  {
    name: "４０４",
    path: '/*',
    children: <Page404 />,
  },
];
